<template>
    <div class="confirm-warpper">
        <input class="code" ref="input" v-model="code" @blur="lose" type="number" @focus="onFocus"
            :maxlength="maxLength" />
        <div @click="focus" class="box">
            <div v-for="(item, index) in loopDiv" :key="index" :class="{ item: true, active: current === index }">{{
                code[index] }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: [String, Number],
            default: 4
        }
    },
    data() {
        return {
            code: '',
            current: -1
        };
    },
    computed: {
        maxLength() {
            return typeof this.size === 'number' ? this.size : Number(this.size);
        },
        loopDiv() {
            return new Array(this.maxLength);
        }
    },
    watch: {
        code(newVal, oldVal) {
            this.code = newVal.toString().slice(0, this.maxLength);
            this.current = this.code.length;
            this.$emit('input', this.code);
        }
    },
    methods: {
        async focus() {
            console.log('---------')
            let len = this.code.length;
            this.current = len === this.maxLength ? this.code.length - 1 : this.code.length;
            this.$nextTick(() => {
                (this.$refs.input).focus();
            });
        },
        lose() {
            this.current = -1;
        },
        onFocus() {
            this.focus();
        }
    },
    mounted() {
        this.focus();
        this.current = -1;
    }
};
</script>

<style lang="scss" scoped>
@keyframes cursor {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.confirm-warpper {
    height: 53px;
}

.code {
    position: absolute;
    left: -200px;
    width: calc(200%);
    height: 50px;
    opacity: 0; 
    z-index: 100;
}

.box {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    cursor: text;
}

.item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 53px;
    height: 53px;
    font-size: 18px;
    font-weight: bold;
    background: #f6f8fa;
    border-radius: 12px;
    color: #111827;
}

.item.active {
    border: 1px solid #FAC859;
}

.item.active::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 24px;
    border: 1px solid #FAC859;
    animation: cursor 1s infinite;
}
</style>


// WEBPACK FOOTER //
// src/components/code-input.vue